import { FilePenRegularIcon, UserDoctorRegularIcon } from "@elixir/icons";
import { Appointment } from "@elixir/types";
import { ChipWithTooltip, IconButton } from "ui";
import { onAppointmentAction } from "../../../../utils/bridges/methods";
import { Dropdown, Tooltip } from "antd";
import SelectDoctorMenu from "../../../cards/queue/select-doctor-menu";
import { getQueueTypeFromStatus } from "../../../../utils/appointment-utils";
import { QUEUE_TYPE } from "../../../../constants/appointments";
import { isClinicLevelApt } from "@elixir/utils/src/appointment-utils";

const AssignDoctor = ({
  apt,
  className = "",
  type,
}: {
  apt: Appointment;
  className?: string;
  type?: "primary" | "secondary";
}) => {
  const queueType = getQueueTypeFromStatus(apt.status);
  return queueType === QUEUE_TYPE.BOOKED ? (
    isClinicLevelApt({ docId: apt.doctor_oid }) ? (
      <Dropdown
        className=""
        trigger={["click"]}
        overlay={<SelectDoctorMenu aptData={apt} />}
      >
        <Tooltip destroyTooltipOnHide title={"Assign Doctor"}>
          <IconButton
            activeClass={`${type === "primary" ? "dr-bg-darwin-neutral-0 hover:dr-bg-darwin-primary-bg-light hover:dr-text-darwin-primary-primary dr-text-darwin-primary-primary dr-border-darwin-primary-primary" : "dr-bg-darwin-neutral-0 hover:dr-text-darwin-neutral-1000 hover:dr-bg-darwin-neutral-50 dr-text-darwin-neutral-600 dr-border-darwin-neutral-200"}`}
            disabledClass="dr-border-darwin-touch-neutral-300 dr-text-darwin-touch-neutral-300 dr-bg-darwin-touch-neutral-0"
            className={`dr-w-32 dr-min-h-32 dr-h-32`}
            icon={<UserDoctorRegularIcon />}
            onClick={(e) => e.stopPropagation()}
          />
        </Tooltip>
      </Dropdown>
    ) : (
      <></>
    )
  ) : (
    <></>
  );
};

export default AssignDoctor;
